import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { spotFinder } from "../app/endpoints";
import axiosBaseQuerySpotfinder from "./axiosBaseQuerySpotfinder";

export const customerBalanceApi = createApi({
  reducerPath: "customerBalanceApi",
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ["customerBalance"],
  endpoints: (builder) => ({
    updateCustomerBalance: builder.mutation({
      query: (body) => {
        return {
          url: spotFinder.customerBalanceController.updateCustomerBalance,
          method: "PUT",
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    findCustomerBalanceByUserId: builder.mutation({
      query: (body) => {
        return {
          url:
            spotFinder.customerBalanceController.findCustomerBalanceByUserId +
            body.customerId,
          method: "GET",
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    getWalletHistory: builder.mutation({
      query: (body) => {
        return {
          url: `${spotFinder.customerBalanceController.getWalletHistory}${body.payload.customerId}/5/${body.payload.pageNumber}`,
          method: "GET",
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
  }),
});


export const {
  useUpdateCustomerBalanceMutation,
  useFindCustomerBalanceByUserIdMutation,
  useGetWalletHistoryMutation,
} = customerBalanceApi;
